document.addEventListener('DOMContentLoaded', function() {
  const variantRadios = document.querySelector('variant-radios');
  if (!variantRadios) return;

  const product = window.product || {};
  const variants = product.variants || [];
  
  // Pour chaque label de variante
  const labels = variantRadios.querySelectorAll('label');
  labels.forEach(label => {
    const input = label.previousElementSibling;
    if (!input || input.type !== 'radio') return;
    
    const variantValue = input.value;
    
    // Trouver la variante correspondante
    const variant = variants.find(v => 
      v.option1 === variantValue || 
      v.option2 === variantValue || 
      v.option3 === variantValue
    );
    
    if (variant && variant.featured_image) {
      // Créer l'image de fond pour le cercle
      label.style.setProperty('--variant-image', `url(${variant.featured_image.src})`);
    }
  });
});
